import { DocumentoComercialAsociadoReadingDtoProps } from "./DTOs/DocumentoComercialAsociadoReadingDto"
import { FicheroReadingDtoProps } from "./DTOs/FicheroReadingDto"
import { PedidoReadingDtoProps } from "./DTOs/PedidoReadingDto"
import { PedidoReadingFiltersDtoProps } from "./DTOs/PedidoReadingFiltersDto"
import { PedidoReadingSimpleDtoProps } from "./DTOs/PedidoReadingSimpleDto"
import { ValidacionDocumentoReadingDtoProps } from "./DTOs/ValidacionDocumentoReadingDto"

export const pedidoByFilterAdapter = (
  pedido: PedidoReadingFiltersDtoProps
): PedidoReadingFiltersDtoProps => {
  return {
    divisa: pedido.divisa,
    estadoRevisionActual: pedido.estadoRevisionActual,
    fechaEmision: pedido.fechaEmision,
    id: pedido.id,
    importe: pedido.importe,
    motivo: pedido.motivo,
    nifLibrado: pedido.nifLibrado,
    nifLibrador: pedido.nifLibrador,
    numero: pedido.numero,
    numeroFicherosAdjuntos: pedido.numeroFicherosAdjuntos,
    paisLibrado: pedido.paisLibrado,
    paisLibrador: pedido.paisLibrador,
    razonSocialLibrado: pedido.razonSocialLibrado,
    razonSocialLibrador: pedido.razonSocialLibrador,
    serie: pedido.serie,
    tipoDocumento: pedido.tipoDocumento,
  }
}

export const pedidoByIdSimple = (
  pedido: PedidoReadingSimpleDtoProps
): PedidoReadingSimpleDtoProps => {
  return {
    id: pedido.id,
    divisa: pedido.divisa,
    empresa: pedido.empresa,
    estadoRevisionActual: pedido.estadoRevisionActual,
    fechaEmision: pedido.fechaEmision,
    fechaVencimiento: pedido.fechaVencimiento,
    importe: pedido.importe,
    motivo: pedido.motivo,
    serieNumero: pedido.serieNumero,
    tipoDocumento: pedido.tipoDocumento,
  }
}

export const pedidoDocAsociadosAdapter = (
  doc: DocumentoComercialAsociadoReadingDtoProps
): DocumentoComercialAsociadoReadingDtoProps => ({
  id: doc?.id,
  numero: doc?.numero,
  serie: doc?.serie,
  tipoDocumento: doc?.tipoDocumento,
})

export const pedidoFicherosAdjuntosAdapter = (
  archivo: FicheroReadingDtoProps
): FicheroReadingDtoProps => ({
  id: archivo.id,
  esDocumentoImportado: archivo.esDocumentoImportado,
  extension: archivo.extension,
  mediaType: archivo.mediaType,
  nombre: archivo.nombre,
  ruta: archivo.ruta,
  tamañoEnBytes: archivo.tamañoEnBytes,
  tipo: archivo.tipo,
})

export const pedidoById = (
  pedido: PedidoReadingDtoProps
): PedidoReadingDtoProps => {
  return {
    id: pedido.id,
    estadoRevisionActual: pedido.estadoRevisionActual,
    tipoDocumento: pedido.tipoDocumento,
    configuracion: pedido.configuracion,
    articuloDocumentos: pedido.articuloDocumentos,
    cliente: pedido.cliente,
    descuento: pedido.descuento,
    diasPago: pedido.diasPago,
    divisa: pedido.divisa,
    documentosAjustesPorDefecto: pedido.documentosAjustesPorDefecto,
    documentosComercialesAsociados: pedido.documentosComercialesAsociados,
    fechaEmision: pedido.fechaEmision,
    fechaOperacion: pedido.fechaOperacion,
    formaPago: pedido.formaPago,
    importe: pedido.importe,
    impuestoRetenido: pedido.impuestoRetenido,
    libradoId: pedido.libradoId,
    libradorId: pedido.libradorId,
    logo: pedido.logo,
    numero: pedido.numero,
    numeroAdjuntos: pedido.numeroAdjuntos,
    observaciones: pedido.observaciones,
    origen: pedido.origen,
    serie: pedido.serie,
    tarifaImpuesto: pedido.tarifaImpuesto,
    tipoDocumentoComercial: pedido.tipoDocumentoComercial,
    totalRetenido: pedido.totalRetenido,
    usuario: pedido.usuario,
    fechaEntrega: pedido.fechaEntrega,
  }
}

export const pedidoDocumentoPendienteValidacionAdapter = (
  documento: ValidacionDocumentoReadingDtoProps
): ValidacionDocumentoReadingDtoProps => ({
  id: documento.id,
  autovalidacion: documento.autovalidacion,
  etapas: documento.etapas,
  rango: documento.rango,
  tipoDocumento: documento.tipoDocumento,
  todosLosRangos: documento.todosLosRangos,
})
